<template>
  <overlay-modal ref="overlayModal" width="65%">
    <template v-slot:header>
      <div class="d-flex justify-content-between">
        <div>
          <h6 class="text-uppercase text-primary mb-0">{{ categoria }}</h6>
          <h4 class="cursive">{{ titolo }}</h4>
        </div>
      </div>
    </template>
    <template>
      <div class="modal-tour-detail">
        <div>
          <big-carousel :images="images" class="mb-3" />
          <div class="mb-3">
            <h5 class="cursive">Scegli il giorno di partenza</h5>
            <div class="d-md-flex my-3" :style="isMobile ? '' : 'height: 35px'">
              <div class="mr-md-2 mb-2 mb-md-0" style="min-width: 250px">
                <CustomDatePicker
                  v-if="dateSelected"
                  placeholder="SCEGLI UNA DATA"
                  v-model="dateSelected"
                  :disabled-dates="disabledDates"
                />
              </div>
              <button
                id="procediExperience"
                class="btn btn-primary px-4"
                @click="onSelectPartenza()"
              >
                procedi
              </button>
            </div>
          </div>
          <tabs class="mb-3">
            <tab title="Descrizione">
              <div class="mb-3">
                <p class="text-justify" v-html="descrizione"></p>
              </div>
            </tab>
            <tab title="Itinerario" @click="onClickItinerario">
              <h4 class="mb-3">Servizi e Trasferimenti</h4>
              <div
                class="mb-3 row"
                v-for="(item, index) in itinerario"
                :key="'x' + index"
              >
                <div class="col-12 col-md-4 pr-md-4">
                  <small-carousel :images="item.imagesUrl" class="mb-3" />
                </div>
                <div class="col-12 col-md-8">
                  <h6 v-if="!item.dateRitorno" class="mb-0">
                    {{ formatDateFromIndex(item.date) }}
                  </h6>
                  <h6 v-else class="mb-0">
                    {{ formatDateFromIndex(item.date) }} -
                    {{ formatDateFromIndex(item.dateRitorno) }}
                  </h6>
                  <h5 class="cursive mb-0">{{ item.name }}</h5>
                  <p class="mb-1 text-uppercase text-nowrap">
                    <img
                      src="../../../../../assets/images/svg/black/icone_passeggeri.svg"
                      height="12px"
                    />
                    <small
                      ><b>{{ item.line }}</b></small
                    >
                    <img
                      v-if="item.durata"
                      class="ml-2"
                      src="../../../../../assets/images/svg/black/icone_durata.svg"
                      height="12px"
                    />
                    <small v-if="item.durata"
                      ><b>{{ item.durata }}</b></small
                    >
                  </p>
                  <p class="text-justify">{{ item.description }}</p>
                </div>
              </div>
              <h4 class="mb-3" v-if="!isTourNotFound">Minitour</h4>
              <div
                v-if="!isTourNotFound"
                class="row no-gutters mb-4"
                v-for="(item, day) in dayByDay"
                :key="day"
              >
                <div class="col-12 col-md-4 pr-md-4">
                  <small-carousel :images="item.imagesUrl" class="mb-3" />
                </div>
                <div class="col-12 col-md-8">
                  <div class="mb-2">
                    <h6 v-if="item.kilometers" class="mb-0">
                      {{ day + 1 }}° giorno ({{ item.kilometers }}) -
                      {{ item.descriptionTitle }}
                    </h6>
                    <h6 v-else class="mb-0">
                      {{ day + 1 }}° giorno - {{ item.descriptionTitle }}
                    </h6>
                    <img
                      src="../../../../../assets/images/svg/black/icone_durata.svg"
                      height="12px"
                    />
                    <small>{{ item.date }}</small>
                  </div>
                  <p class="text-justify">{{ item.description }}</p>
                  <div v-if="item.categoryDescriptions.length > 0">
                    <table
                      class="table"
                      style="font-size: 0.75rem"
                      v-if="
                        item.categoryDescriptions.some(
                          (cat) => cat.hotels.length > 0
                        )
                      "
                    >
                      <thead>
                        <tr>
                          <th>Categoria</th>
                          <th>Sistemazione</th>
                          <th>Trattamento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="cat in item.categoryDescriptions"
                          :key="cat.category"
                        >
                          <td>
                            <p class="mb-0">{{ cat.category }}</p>
                          </td>
                          <td>
                            <p class="mb-0">{{ hotelNames(cat.hotels) }}</p>
                          </td>
                          <td>
                            <p class="mb-0">{{ cat.treatment }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table" style="font-size: 0.75rem" v-else>
                      <thead>
                        <tr>
                          <th width="50%">Categoria</th>
                          <th width="50%">Trattamento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="cat in item.categoryDescriptions"
                          :key="cat.category"
                        >
                          <td>
                            <p class="mb-0">{{ cat.category }}</p>
                          </td>
                          <td>
                            <p class="mb-0">{{ cat.treatment }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </tab>
          </tabs>
        </div>
      </div>
    </template>
  </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OverlayModal from "../../../../modals/OverlayModal";
import CustomDatePicker from "../../../common/CustomDatePicker";
import CustomGoogleMap from "../../../common/CustomGoogleMap";
import BigCarousel from "../../../common/BigCarousel";
import {
  longDateFormatter,
  middleDateFormatter,
  toDateFromServer,
} from "../../../../../utils/formatter";
import AnalyticEvents from "../../../../common/AnalyticEvents";
import MobileDetector from "../../../../common/MobileDetector";
import SmallCarousel from "../../../common/SmallCarousel";

export default {
  name: "ModalExperienceDetail",
  mixins: [AnalyticEvents, MobileDetector],
  props: {
    value: Object,
  },
  data() {
    return {
      itinerario: [],
      dateSelected: null,
      tours: [],
    };
  },
  components: {
    SmallCarousel,
    BigCarousel,
    CustomGoogleMap,
    CustomDatePicker,
    OverlayModal,
  },
  computed: {
    search() {
      return this.getSearch();
    },
    paginationStyle() {
      return this.images.length > 1 ? "simple with-bottom-area" : "simple";
    },
    titolo() {
      return this.value.titolo;
    },
    categoria() {
      return this.value.codiceCategoria.name;
    },
    images() {
      if (!this.value.images) return [];
      return this.value.images;
    },
    descrizione() {
      return this.value.descrizione;
    },
    disabledDates: function () {
      const days = this.value.daysSelected;
      return {
        customPredictor: (date) => {
          const now = this.$moment();
          const cdate = this.$moment(date);
          const weekDay = this.$moment(date).isoWeekday();
          return !(cdate.isAfter(now) && days[weekDay - 1]);
        },
      };
    },
    isTourNotFound() {
      return (
        this.tours.length === 0 ||
        this.tours[0].actionResultObject.object.tourDetailResponses.length === 0
      );
    },
    dayByDay() {
      if (this.isTourNotFound) return;
      const tour =
        this.tours[0].actionResultObject.object.tourDetailResponses[0].detail;
      const list = tour.dayByDay;
      const partenza = toDateFromServer(this.tours[0].date.date);
      return list.map((item, index) => {
        const date = middleDateFormatter(
          this.$moment(partenza).add(index, "days")
        );
        return { ...item, date };
      });
    },
  },
  methods: {
    ...mapGetters(["getSearch"]),
    ...mapActions(["addSearch"]),
    open(dateSelected, services, tours) {
      this.tours = tours;
      this.dateSelected = dateSelected;
      this.itinerario = this.makeItinerario(services);
      this.$nextTick(() => {
        this.$refs.overlayModal.open();
      });
    },
    close() {
      this.$refs.overlayModal.close();
    },
    onClickItinerario() {
      if (this.isHomePage) {
        this.trackHomeModaleExperienceItinerario();
      } else {
        this.trackResultModaleExperienceItinerario();
      }
    },
    onSelectPartenza() {
      this.trackResultModaleExperienceProcedi();
      this.$emit("select", {
        experience: this.value,
        partenza: this.dateSelected,
      });
    },
    makeItinerario(services) {
      if (!services) return [];
      const { days } = this.value;
      const sameTrasfAR = this.sameTrasferimentoAndataRitorno();
      const list = services
        .filter((item) => this.getDayIndex(item) > 0)
        .map((item) => {
          const { line, name, places, description, productID } =
            item.response.detail;
          // Deve individuare la data da stampare:
          // - controlla se il productID del servizio è associato ad un codice tour
          // - controlla se il productID del servizio è associato un codice servizio in lista
          const dayIndex = this.getDayIndex(item);
          // override del nome
          const itemFound = days[dayIndex].list.find(
            (dayService) => dayService.codiceServizio === productID
          );
          const nameOverride = itemFound.nome ? itemFound.nome : name;
          const imagesUrl = item.response.detail.imagesUrl;
          const date = this.$moment(this.dateSelected)
            .add(dayIndex, "days")
            .toDate();
          const dateRitorno =
            this.isTrasferimento(productID) && sameTrasfAR && dayIndex === 0
              ? this.$moment(this.dateSelected)
                  .add(days.length - 1, "days")
                  .toDate()
              : null;
          return {
            productID,
            date,
            dateRitorno,
            line,
            name: nameOverride,
            markers: this.makeMarkers(places),
            description,
            imagesUrl,
          };
        });
      return list.sort(function (a, b) {
        return a.date.getTime() - b.date.getTime();
      });
    },
    getDayIndex(item) {
      const { productID } = item.response.detail;
      const { days } = this.value;
      return days.findIndex((item) => {
        if (item.codiceTour === productID) return true;
        return (
          item.list &&
          item.list.length > 0 &&
          item.list.some(
            (dayService) => dayService.codiceServizio === productID
          )
        );
      });
    },
    formatDateFromIndex(date) {
      return longDateFormatter(date);
    },
    makeMarkers(places) {
      return places.map((item) => {
        return {
          title: item.name,
          lat: item.coordinate.latitude,
          lng: item.coordinate.longitude,
        };
      });
    },
    hotelNames(list) {
      if (!list || list.length === 0) return "";
      return list.map((h) => h.location.name).reduce((t, c) => t + " " + c);
    },
    isTrasferimento(code) {
      return this.value.days
        .filter((day) => day.list)
        .some((day) => {
          return day.list
            .filter((item) => item.isTrasferimento === true)
            .some((item) => {
              return (
                code === item.codiceServizio && item.isTrasferimento === true
              );
            });
        });
    },
    sameTrasferimentoAndataRitorno() {
      let list = [];
      this.value.days.forEach((day, index) => {
        if (day.list) {
          const results = day.list
            .map((item) => {
              return {
                code: item.codiceServizio,
                day: index,
                isObbligatorio: item.isObbligatorio,
                isTrasferimento: item.isTrasferimento === true,
              };
            })
            .filter((item) => item.isTrasferimento === true);
          list = list.concat(results);
        }
      });
      return list.length === 2 && list[0].code === list[1].code;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/experience/modals/ModalExperienceDetail.vue